import Comments from './Comments';
import BlogDetails from './BlogDetails';
import React, { Fragment } from 'react';
import { Col, Card } from 'reactstrap';

const LearningDeatil = () => {
  return (
    <Fragment>
      <Col xxl='9' xl='8' className='box-col-70 order-2 order-xl-1'>
        <div className='blog-single'>
          <BlogDetails />
          <Card className='comment-box'>
            <Comments />
          </Card>
        </div>
      </Col>
    </Fragment>
  );
};

export default LearningDeatil;
